<template lang="pug">
#menu
	.SidebarContainer
		aside.Sidebar
			header.SidebarHeader
				div(style="padding-top:2px; padding-bottom:2px; ")
					img(:src="'img/'+ img ", height="58") 
			.SidebarContent
				nav#SidebarNav.SidebarNav(v-if="listaTipoMenu", v-for="(listp,key) in listaTipoMenu")
					a.NavLink.-active(v-if="key==0",href="#/")
						i.fa.fa-home.NavIcon
						span  Inicio
							a.btn(href="/", style="color:#FFF; font-size:12px;")          
					div(v-bind:class="{ 'NavGroup' : item.NavGroup== 0 ? true:false, 'NavGroup -open' : item.NavGroup== 1 ? true:false    }" v-for="item of menuItem.filter(b => b.Tipo==listp.Tipo)")
						a.NavLink(@click="click_item(item.Name)")
							i(v-bind:class="item.Class")
							span  {{item.Name}}
						nav.Nav.lineaabajo( v-bind:class="{ 'efecto_desaparece' : item.NavGroup==0 ? true:false ,  'efecto_aparece' : item.NavGroup==1 ? true:false}")
							.CompactNavGroupHeader
								h4.NavTitle  {{item.Name}} 
								a.Button.-dismiss.DismissBtn(@click="item.NavGroup = item.NavGroup == 0 ? 1:0")
									i.fa.fa-times.Icon(style="color:white")
							div(v-if="menuSubItem" v-for="(subitem,key) of menuSubItem.filter(b=> b.Id_Item==item.Id)" :key="subitem.Id")
								div(v-if="key==0 || ( key>0 && menuSubItem.filter(b=> b.Id_Item==item.Id)[key-1].Name!=subitem.Name)")                  
									router-link.NavLink.DismissBtn(v-if="!subitem.Sub_name", :to="subitem.Path" @click.native="click_subitem(subitem.Name); $emit('closeMenuMobile'); cerrarSubMenu();")  {{subitem.Name}} 
									a.NavLink.SubMenu(v-else,@click="click_subitem(subitem.Name)",v-bind:class="{ 'NavGroup' : subitem.SubNavGroup== 0 ? true:false, 'NavGroup -open' : subitem.SubNavGroup== 1 ? true:false    }") {{subitem.Name}} 
									nav.Nav2( v-bind:class="{ 'efecto_desaparece' : subitem.SubNavGroup==0 ? true:false ,  'efecto_aparece' : subitem.SubNavGroup==1 ? true:false}")
											router-link.NavLink(v-if="menuSubItem" v-for="subsubitem of menuSubItem.filter(b=> b.Name==subitem.Name && b.Sub_name!='' &&  b.Sub_name!=null )" :key="subsubitem.Id" :to="subsubitem.Path" @click.native="$emit('closeMenuMobile'); cerrarSubMenu();")  {{subsubitem.Sub_name}}
					.Divider                    
			nav.SidebarFooterNav(style='text-align:right;')
				button.SidebarToggleCompactLink.NavLink.LinkToggleCompact.col-md-12.text-right( @click="$emit('compactMenu')", style="  border-style: outset!important; border-width:0px!important" )
					i.fa.fa-angle-left.fa-3x(aria-hidden='true', style="margin-right: 15px, color:white")
				button#btnCerrarMenu.col-md-12.text-right( @click="$emit('closeMenu')")
					i.fa.fa-angle-right.fa-3x 
</template>
<script>
 export default {
		props: ['menuItem','menuSubItem'] ,
		data(){
			console.log(this.menuSubItem);
			return{
					listaTipoMenu:[],
					img:''
			}
		},
		created(){

				this.img=this.$info.img
				this.generateListaTip()
				console.log('Menu Items:', this.menuItem);
  				console.log('Menu Subitems:', this.menuSubItem);
		},

		methods : {
				generateListaTip(){

					for (let i = 0; i < this.menuItem.length; i++) 
						{
							if(i==0 || (i>0 && this.menuItem[i-1].Tipo!=this.menuItem[i].Tipo) )
							this.listaTipoMenu.push({Tipo: this.menuItem[i].Tipo })
						}

				},
				cerrarSubMenu(){
					if (window.innerWidth<768 || screen.width<768)
					{
						this.menuItem.forEach(element => {
								
										element.NavGroup=0
					})
					}
				},
				validaCerrar(){
							 if (window.innerWidth<768 || screen.width<768){
								 this.$emit('send2')
							 }             

					},

				click_item(itemname){          
						 this.menuItem.forEach(element => {
								if(element.Name!=itemname)
									{
										element.NavGroup=0
									}
								else
									{ 
										element.NavGroup= element.NavGroup==0 ? 1:0
									}
						 });

					},
				click_subitem(itemname){          
						 this.menuSubItem.forEach(element => {
								if(element.Name!=itemname)
									{
										element.SubNavGroup=0
									}
								else
									{ 
										element.SubNavGroup= element.SubNavGroup==0 ? 1:0
									}
						 });

					}
		}
		,
		computed : {
			getView(){
				return ;
			},
			
		}
		
 }
 
</script>
	<style>
		.SubMenu::after {
				display: inline-block;
				font: normal normal normal 14px/1 FontAwesome;
				font-size: 14px;
				font-size: inherit;
				text-rendering: auto;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
				display: block;
				content: "\F054";
				font-size: .8em;
				position: absolute;
				right: 10px;
				top: 50%;
				margin-top: 2px;
				-webkit-transition: -webkit-transform .3s ease;
				transition: -webkit-transform .3s ease;
				transition: transform .3s ease;
				transition: transform .3s ease, -webkit-transform .3s ease;
				-webkit-transform: translate(0, -50%);
				transform: translate(0, -50%);
		}
	.NavLink.router-link-exact-active::after{
					display: inline-block;
					font: normal normal normal 14px/1 FontAwesome;
					font-size: 12px;
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					display: block;
					content: "\f1ae";
					font-size: 1.8em;
					position: absolute;
					right: 10px;
					top: 50%;
					margin-top: 2px;
					-webkit-transition: -webkit-transform .3s ease;
					transition: -webkit-transform .3s ease;
					transition: transform .3s ease;
					transition: transform .3s ease, -webkit-transform .3s ease;
					-webkit-transform: translate(0, -50%);
					transform: translate(0, -50%);
			}
		.SubMenu.-open::after {
		-webkit-transform: translate(0, -50%) rotate(90deg);
		transform: translate(0, -50%) rotate(90deg);
		}

		.NavLink.router-link-exact-active{
				background-color: #f0a900;     
				color: white;
				font-weight: 500;  
				font-size: 15x!important;
		} 
		.Nav2{ 
			overflow-x: visible;
			overflow-y: hidden;
			background-color: #75818D; 
		}
		.lineaabajo a {
			-webkit-box-shadow: 0px 1px 1px 1px rgba(3, 3, 63, 0.1);
			-moz-box-shadow: 0px 1px 1px 1px rgba(3, 3, 63, 0.1);
			box-shadow: 0px 1px 1px 1px rgba(3, 3, 63, 0.1); 
			white-space:normal!important;
			padding: 20px 30px 20px 51px!important; 
		 }
		.Nav2 a{       
			-webkit-box-shadow: 0px 1px 1px 1px rgba(81, 83, 97, 0.1);
			-moz-box-shadow: 0px 1px 1px 1px rgba(81, 83, 97, 0.1);
			box-shadow: 0px 1px 1px 1px rgba(81, 83, 97, 0.1);
		}
		.efecto_desaparece {
			visibility: hidden;
			opacity: 1;
			max-height: 0;
			transition: all 0.2s ease 0.15s;
			-moz-transition: all 0.2s ease 0.15s;
			-webkit-transition: all 0.2s ease 0.15s;
			-o-transition: all 0.2s ease 0.15s;
		}
		.efecto_aparece {
			visibility: visible;
			max-height: 500px;
			-moz-transition: max-height 0.6s ease-in;
			-o-transition: max-height 0.6s ease-in;
			-webkit-transition: max-height 0.6s ease-in;
			transition: max-height 0.6s ease-in;
		}
 @media only screen and (max-width: 767px) {
		.SidebarToggleCompactLink {        
					display: none;
		}
		#btnCerrarMenu {     
				border:none;
				display: block;
		}
		}
	@media only screen and (min-width: 766px) {
		#btnCerrarMenu {
					display: none;
		}
		.SidebarToggleCompactLink {
				border:none;
				display: block;
		}
}
</style>
